export default {
  loginAsAgent: {
    info: {
      perfix: "Logged as ",
    },
    logout: {
      button: "Log out",
    },
  },
  nav: {
    home: "Home",
    logout: "Logout",
    dashboard: "Dashboard",
    "account-settings": "Account Settings",
    "user-profile": "My Profile",
    "user-guide": "User Guide",
    "help-centre": "Help Centre",
    watermark: "Watermark Settings",
    listings: "Listings",
    listingsManagement: "Listings management",
    scheduledManager: "Scheduled Readvertising Manager",
    reportings: "Agent Listing Report ",
    insights: "Insights",
    marketAnalytics: "Market Analytics",
    marketWatch: "MarketWatch",
    iqAgent: "Home Report",
    brickz: "Brickz",
    leads: "Leads",
    agentools: "Agentools",
    searchProperty: "Search Properties",
    propertyWanted: "Property Wanted",
    fsbo: "FSBO Alerts",
    addListing: "Create listing",
    announcements: "Announcements",
    adminTools: "Admin tools",
    areaCondoSpecialist: "Area Condo Specialist",
    specialistReport: "Specialist Report",
    buy: "Buy",
    agentNet: "Open in AgentNet",
  },
  title: "iProperty Pro",
  account: {
    agent: "My profile",
    subscriptions: "My Subscriptions & Packages",
    paymentHistory: "Payment History",
    team: "Members",
    management: "Agency / Branch management",
    setting: "Settings",
    enquiryManagement: "Enquiry management",
    enquiry: "Enquiry settings",
    allocations: "Allocations",
    logOut: "Log out",
    logIn: "Log in",
    openConsumer: "Open iproperty.com.my",
    quality: "QC Admin Dashboard",
  },
  language: {
    language: "Language",
    back: "Back",
  },
  notification: {
    title: "Notification",
    emptySubject: "No new notifications yet",
    emptyMessage: "We will let you know when we have news for you :)",
  },
};
